import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/compact/flex-10-gbe.png";
import type { Product } from "../../types";
import { productListSwitchingCompact } from "../product-list-groups/productListSwitchingCompact";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  ports,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const flex10GbE: Product = {
  id: "flex10GbE",
  productTitle: "Flex 10 GbE",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/unifi-flex-xg"],
  storePathParts: {
    productSlug: "unifi-flex-xg",
    category: "switching-utility",
  },
  sku: "USW-Flex-XG",
  description: "flex10GbE.description",
  descriptionMaxWidth: 150,
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListSwitchingCompact,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '135 x 185 x 32 mm\n(5.3 x 7.3 x 1.3")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer2",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "5" },
    },
    {
      propertyId: ports.id,
      value: {
        type: "string",
        value: "(4) 10 GbE RJ45\n(1) GbE RJ45",
      },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "10 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: {
        type: "translation",
        value: "commons.speed.upTo10Gbps",
      },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "flex10GbE.powerMethod",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "flex10GbE.mounting",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
